var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"model-2"},[_c('div',{staticClass:"editor-wrapper",style:({backgroundColor:_vm.editablePageConfig.editable_page_config_content.back_color})},[_c('div',{staticClass:"html",domProps:{"innerHTML":_vm._s(_vm.editablePageConfig.editable_page_config_content.editor_content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }